
import { Link } from "react-router-dom";

import * as enrollServices from "../../../../../services/enrollServices"

import DownloadAttList from "../details/DownloadAttList";
import MailToAll from "../details/MailToAll";

import css from "./StudentList.module.css"
import ViewCertificateButton from "../../../_common/elements/ViewCertificateButton";
import RollbackButton from "../../../_common/elements/RollbackButton";

function StudentList ({
    courseDetails,
    setCourseDetails,
    message,
    setMessage
}) {


    const onConfirmRollback = (enrollId) => {
            enrollServices
                .del({ _id: enrollId })
                .then((result) => {
                    setCourseDetails(courseDetails.filter((x) => x.enrollId !== enrollId));
                    console.log(result.message);
                })
                .catch((error) => {
                    console.log(error.message);
                });
        };


    const attHandle = (e) => {
            // console.log(e.currentTarget.checked);
            // console.log(e.currentTarget.name);
    
            const _id = Number(e.currentTarget.id);
            const value = e.currentTarget.checked ? 1 : 0;
            const attribute = e.currentTarget.name;
    
            let updatedArr = courseDetails.map((el) => {
                if (el.enrollId === _id) {
                    el[attribute] = value;
                }
    
                return el;
            });
            enrollServices
                .edit({
                    _id: _id,
                    isAtt: attribute === 'isAtt' ? value : courseDetails.filter((a) => a.enrollId === _id)[0].isAtt,
                    isPass: attribute === 'isPass' ? value : courseDetails.filter((a) => a.enrollId === _id)[0].isPass,
                })
                .then((result) => {
                    setCourseDetails(updatedArr);
                    setMessage((message) => result.message);
    
                    setTimeout(() => {
                        setMessage((message) => '');
                    }, 1000);
                    // console.log(result.message);
                })
                .catch((error) => {
                    console.log(error.message);
                });
        };

    return (
        <div className={css.course}>
                <h2 className={css.h2}>Student List</h2>
                <div className={css.infoBar}>
                    <DownloadAttList data={courseDetails} />
                    <MailToAll courseDetails={courseDetails} />
                    <p className={css.infoMessage}>{message}</p>
                </div>
                <table className={css.table}>
                    <thead className={css.thead}>
                        <tr>
                            <th className={css.th}>No</th>
                            <th className={css.th}>Name</th>
                            <th className={css.th}>Customer</th>
                            <th className={css.th}>Cat</th>
                            <th className={css.th} style={{ textAlign: 'center' }}>
                                Att?
                            </th>
                            <th className={css.th} style={{ textAlign: 'center' }}>
                                Pass?
                            </th>
                            <th className={css.th} style={{ textAlign: 'center' }}>
                                Cert/RB
                            </th>
                            {/* <th className={css.th}></th> */}
                        </tr>
                    </thead>
                    <tbody className={css.tbody}>
                        {courseDetails.map((x, i) =>
                            courseDetails[0].requestId ? (
                                <tr key={x.requestId} id={x.requestId}>
                                    <td>{i + 1}</td>
                                    <td>
                                        <Link className={css.link} to={`/student/details/${x.studentNo}`}>
                                            ({x.studentNo}) {x.studentName}
                                        </Link>
                                    </td>
                                    <td>{x.customerNameShort}</td>
                                    <td>{x.licenseCategoryTitle}</td>
                                    <td style={{ textAlign: 'center' }}>
                                        <input
                                            id={x.enrollId}
                                            name="isAtt"
                                            className={css.checkBox}
                                            type="checkbox"
                                            checked={x.isAtt}
                                            onChange={attHandle}
                                        />
                                    </td>
                                    <td style={{ textAlign: 'center' }}>
                                        <input
                                            id={x.enrollId}
                                            name="isPass"
                                            className={css.checkBox}
                                            type="checkbox"
                                            checked={x.isPass}
                                            onChange={attHandle}
                                        />
                                    </td>
                                    <td style={{ textAlign: 'center' }}>
                                        {x.certificateLink ? (
                                            x.certificateLink && <ViewCertificateButton certificateLink={x.certificateLink} />
                                        ) : (
                                            ['Closed', 'Cancelled'].some(st => st === x.courseStatusName) ? (
                                                <></>
                                            ) : (

                                                <RollbackButton enrollId={x.enrollId} onConfirm={onConfirmRollback} />
                                            )
                                        )}
                                    </td>
                                    {/* <td style={{ textAlign: 'center' }}>
                                        {(!x.courseTitle || Number(x.courseStatusId) === 3) || x.certificateLink? (
                                            <></>
                                        ) : (
                                            <RollbackButton enrollId={x.enrollId} onConfirm={onConfirmRollback} />
                                        )}
                                    </td> */}
                                </tr>
                            ) : (
                                <tr>
                                    <td colSpan={5} style={{ textAlign: 'center' }}>
                                        No matching records found.
                                    </td>
                                </tr>
                            )
                        )}
                    </tbody>
                </table>
            </div>
    )
}

export default StudentList;